package pwgs.ui.scenes.userreportsscene

import visage.core.AComponent
import visage.core.Components
import visage.core.AScene
import visage.core.Navigation
import visage.ds.components.Card
import visage.ds.components.Table
import visage.ds.components.page.Page
import kotlin.js.Date

class MUserReportsScene(props: UserReportsSceneProps) : AScene<UserReportsSceneProps, UserReportsSceneModel, UserReportsSceneState, UserReportsControllerFe>(props) {

    override fun createController() : UserReportsControllerFe {
        return UserReportsControllerFe(props, this)
    }

    override fun initState() : UserReportsSceneState {
        return UserReportsSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        val m = this@MUserReportsScene.model
        val c = this@MUserReportsScene.controller
        Page {
            head("User Reports")
            body {
                Card {
                    isLoading = m.isLoading
                    header("User Reports")
                    body {
                        Table {
                            columns {
                                fixedColumn("Reporter ID")
                                fixedColumn("Reporter Name")
                                fixedColumn("Reported Player ID")
                                fixedColumn("Reported Player Name")
                                fixedColumn("Reason")
                                fixedColumn("Reported at")
                            }
                            body {
                                if (!m.isLoading) {
                                    m.items.forEach {
                                        row {
                                            cell(it.reporterId)
                                            cell(it.reporterUserName)
                                            cell(it.reportedUserId)
                                            cell(it.reportedUserName)
                                            cell(it.reason)
                                            cell(Date(it.reportedAt).toLocaleString())

                                            onClick = { oc ->
                                                Navigation.pushLocation("/app/project/${this@MUserReportsScene.props.projectId}/player/${it.reportedUserId}/index.vsg")
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

class UserReportsSceneState {

}

fun Components.UserReportsScene(props: UserReportsSceneProps) = this.registerComponent(MUserReportsScene(props), {})
